import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'logout', method: 'POST', body: null, token: token })
}
